var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserCircleFilled = function SvgUserCircleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 23.314A12 12 0 0 1 12 24c-1.402 0-2.748-.242-4-.686V21c0-2.206 1.794-4 4-4s4 1.794 4 4zM12 7c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2m12 5c0 4.433-2.416 8.311-6 10.389V21c0-3.309-2.691-6-6-6s-6 2.691-6 6v1.389C2.416 20.311 0 16.433 0 12 0 5.383 5.383 0 12 0s12 5.383 12 12m-8-3c0-2.206-1.794-4-4-4S8 6.794 8 9s1.794 4 4 4 4-1.794 4-4"
  })));
};
export default SvgUserCircleFilled;